<mat-form-field class="dob-form-field">
  <mat-label></mat-label>
  <mat-select
    [disabled]="isDOBValid"
    [placeholder]="this.labels.MONTH"
    [(ngModel)]="selectedMonth"
    (selectionChange)="monthChanged($event.value)"
  >
    <mat-option *ngFor="let month of months" [value]="month">
      {{ month }}
    </mat-option>
  </mat-select>
</mat-form-field>
&nbsp;
<mat-form-field class="dob-form-field">
  <mat-label></mat-label>
  <mat-select
    [disabled]="isDOBValid"
    [placeholder]="this.labels.DAY"
    [(ngModel)]="selectedDate"
    (selectionChange)="dateChanged($event.value)"
  >
    <mat-option *ngFor="let date of dates" [value]="date">
      {{ date }}
    </mat-option>
  </mat-select>
</mat-form-field>
&nbsp;
<mat-form-field class="dob-form-field">
  <mat-label></mat-label>
  <mat-select
    [disabled]="isDOBValid"
    [placeholder]="this.labels.YEAR"
    [(ngModel)]="selectedYear"
    (selectionChange)="yearChanged($event.value)"
  >
    <mat-option *ngFor="let year of years" [value]="year">
      {{ year }}
    </mat-option>
  </mat-select>
</mat-form-field>
